import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// eslint-disable-next-line import/prefer-default-export
export function usePageViews() {
  const location = useLocation();
  useEffect(() => {
    if ((window as any).isHeadless) {
      return;
    }
    (window as any).bwtag('set', 'appId', process.env.REACT_APP_BRIGHTWRITE_APP_ID);
    (window as any).bwtag('set', 'appVersion', process.env.REACT_APP_BRIGHTWRITE_APP_VERSION);
  }, []);
  useEffect(() => {
    if ((window as any).isHeadless) {
      return;
    }
    (window as any).bwtag('pv');
  }, [location]);
}
